<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="assignments-list" v-bind:key="index" v-for="(resource, index) in resourcesList">
            <div class="profession label-style row q-pb-sm" v-if="!resourcesList[index-1] || (resourcesList[index-1].type.name!=resource.type.name)">
                <div class="col">
                    {{ resource.type.name }} ({{ resourcesCount[resource.type.id].count }})
                </div>
            </div>
            <div class="assignment">
                <ResourceTrackingInput
                    :resource="resource"
                    :accessLevel="accessLevel"
                    :variables="variables"
                    :hasError="projectAssignmentWithError[projectShiftId+'-'+resource.id]"
                    :hasDraft="(resource.pivot) ? resource.pivot.hasDraft : true"
                    :initialResourceType="resource.type.id"
                    @unassign="$emit('unassign', resource)"
                    @remove-resource="$emit('remove-resource', resource)"
                    :availableStaffVehicules="availableStaffVehicules"
                    @input="$emit('update-resource', {
                        new: $event,
                        old: resource
                    })"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import orderBy from "lodash/orderBy";

    export default {
        name: 'ResourcesTrackingList',
        props: [
            "resources",
            "staffVehicules",
            "variables",
            "projectAssignmentWithError",
            "accessLevel",
            "availableStaffVehicules",
            "projectShiftId"
        ],
        data(){
            return {
                setValueTO: null,
                selectTO: null,
                focused: null
                // resourcesCount: {}
            }
        },
        mounted(){
        },
        methods: {
            setBlur(event){
                event.target.blur();
                this.focused=null
            },
            setFocus(event, assignement/*, value*/){
                clearTimeout(this.selectTO);
                this.selectTO=setTimeout(function(){
                    event.target.select();
                }, 100);

                this.focused=assignement.type.id;
            },
            setValue(event/*, resource, count*/) {
                let value=event.target.value;
                if(value>100) value=100;
                clearTimeout(this.setValueTO)
                this.setValueTO=setTimeout(function(){
                    // this.$emit('set-resources-count', { profession: {id: resource.type.id, name: resource.type.name}, value: parseInt(value)-parseInt(count) } )
                }.bind(this), 500)
            }
        },
        computed: {
            resourcesCount(){
                let resourcesCount={};
                this.resourcesList.forEach(function (resource) {
                    let typeId = resource.type.id
                    if(resource.isUserVehicule) typeId = 'staffVehicules'
                    if(!resourcesCount[typeId]) resourcesCount[typeId]={count: 0, assignedCount: 0};
                    resourcesCount[typeId].count++;
                    if(resource.assignedTo) resourcesCount[typeId].assignedCount++;
                    resourcesCount[typeId].value=resourcesCount[typeId].assignedCount+' / '+resourcesCount[typeId].count;
                    if(this.focused==typeId) resourcesCount[typeId].value=resourcesCount[typeId].count;
                }.bind(this))
                return resourcesCount;
            },
            resourcesList() {


                let resources = (this.resources) ? JSON.parse(JSON.stringify(this.resources)) : [];
                let staffVehicules = (this.staffVehicules) ? JSON.parse(JSON.stringify(this.staffVehicules)) : [];

                staffVehicules.map(item => {
                    item.type.id="staffVehicules"
                    item.type.name="Véhicule personnel"
                })


                return orderBy(resources.concat(staffVehicules), [item => item.type.name.toLowerCase()], ['asc'])

            },
        }
    }
</script>